// Mock news data for different languages
// This simulates the RSS feed data that would be fetched from real sources

export const getMockNews = (language) => {
  const newsData = {
    en: [
      {
        id: 1,
        title: 'Indian Markets Hit Record Highs as FII Inflows Surge',
        subtitle: 'Sensex crosses 74,000 mark for the first time as foreign institutional investors pour billions into Indian equities.',
        bullets: [
          'Sensex surged past 74,000 for the first time in history',
          'Foreign institutional investors (FIIs) have invested over $5 billion in June',
          'Banking and IT sectors led the rally with gains of over 2%'
        ],
        source: 'Reuters',
        date: new Date(Date.now() - 1800000).toISOString(),
        link: 'https://www.reuters.com/markets/asia/',
        sentiment: 'bullish'
      },
      {
        id: 2,
        title: 'RBI Holds Repo Rate Steady at 6.5% for Eighth Time',
        subtitle: 'Reserve Bank of India maintains status quo on interest rates amid inflation concerns and global economic uncertainty.',
        bullets: [
          'Repo rate unchanged at 6.5%, in line with market expectations',
          'MPC voted 4-2 to maintain the withdrawal of accommodation stance',
          'RBI raises GDP growth forecast to 7.2% for FY25'
        ],
        source: 'MarketWatch',
        date: new Date(Date.now() - 3600000).toISOString(),
        link: 'https://www.marketwatch.com/',
        sentiment: 'neutral'
      },
      {
        id: 3,
        title: 'Reliance Industries Plans $10 Billion Green Energy Push',
        subtitle: 'India\'s largest company by market cap announces massive investment in renewable energy infrastructure.',
        bullets: [
          'Investment to focus on solar panels, hydrogen, and battery storage',
          'Target to achieve net-zero carbon emissions by 2035',
          'Stock rallied 3% following the announcement'
        ],
        source: 'Bloomberg',
        date: new Date(Date.now() - 7200000).toISOString(),
        link: 'https://www.bloomberg.com/markets',
        sentiment: 'bullish'
      },
      {
        id: 4,
        title: 'Global Oil Prices Slide on Demand Concerns',
        subtitle: 'Brent crude falls below $80 per barrel as economic slowdown fears weigh on commodities.',
        bullets: [
          'Brent crude drops to $78.50, lowest in three weeks',
          'China\'s economic data points to slower industrial growth',
          'OPEC+ considers extending production cuts'
        ],
        source: 'CNBC',
        date: new Date(Date.now() - 10800000).toISOString(),
        link: 'https://www.cnbc.com/world/',
        sentiment: 'bearish'
      },
      {
        id: 5,
        title: 'Tech Stocks Rally as AI Optimism Continues',
        subtitle: 'NASDAQ leads gains with major technology companies reporting strong AI-driven revenue growth.',
        bullets: [
          'NVIDIA shares surge 5% on data center demand',
          'Microsoft and Google announce new AI enterprise solutions',
          'Tech sector market cap exceeds $15 trillion'
        ],
        source: 'Reuters',
        date: new Date(Date.now() - 14400000).toISOString(),
        link: 'https://www.reuters.com/technology/',
        sentiment: 'bullish'
      },
      {
        id: 6,
        title: 'Tata Motors EV Sales Double in Q2',
        subtitle: 'Electric vehicle adoption accelerates in India as Tata Motors reports strong quarterly performance.',
        bullets: [
          'EV sales reached 50,000 units in Q2, up 100% YoY',
          'Nexon EV remains the best-selling electric car in India',
          'Company plans to launch 5 new EV models by 2025'
        ],
        source: 'Economic Times',
        date: new Date(Date.now() - 18000000).toISOString(),
        link: 'https://economictimes.indiatimes.com/markets',
        sentiment: 'bullish'
      },
    ],
    'en-US': [
      {
        id: 7,
        title: 'Fed Signals Potential Rate Cut in September',
        subtitle: 'Federal Reserve hints at easing monetary policy as inflation shows signs of cooling.',
        bullets: [
          'Fed Chair Powell indicates data supports rate cuts',
          'Markets pricing in 75% probability of September cut',
          'Treasury yields fall sharply on the news'
        ],
        source: 'CNBC',
        date: new Date(Date.now() - 2400000).toISOString(),
        link: 'https://www.cnbc.com/economy/',
        sentiment: 'bullish'
      },
      {
        id: 8,
        title: 'Apple Announces Record iPhone Sales in Americas',
        subtitle: 'Tech giant reports strongest quarterly performance driven by iPhone 15 Pro demand.',
        bullets: [
          'iPhone revenue up 12% year-over-year in the Americas',
          'Services segment continues double-digit growth',
          'Stock hits new all-time high above $220'
        ],
        source: 'CNBC',
        date: new Date(Date.now() - 5400000).toISOString(),
        link: 'https://www.cnbc.com/technology/',
        sentiment: 'bullish'
      },
      {
        id: 9,
        title: 'Tesla Faces Production Challenges in Texas Gigafactory',
        subtitle: 'Electric vehicle maker reports temporary slowdown due to supply chain issues.',
        bullets: [
          'Cybertruck production running at 60% of target capacity',
          'Battery cell supply remains the primary bottleneck',
          'Company maintains full-year delivery guidance'
        ],
        source: 'MarketWatch',
        date: new Date(Date.now() - 9000000).toISOString(),
        link: 'https://www.marketwatch.com/investing/stock/tsla',
        sentiment: 'bearish'
      },
      {
        id: 10,
        title: 'US Job Market Remains Strong Despite Recession Fears',
        subtitle: 'Latest employment data shows robust hiring activity across multiple sectors.',
        bullets: [
          'Non-farm payrolls added 272,000 jobs in May',
          'Unemployment rate steady at 4.0%',
          'Wage growth moderates to 4.1% annually'
        ],
        source: 'CNBC',
        date: new Date(Date.now() - 12600000).toISOString(),
        link: 'https://www.cnbc.com/economy/',
        sentiment: 'neutral'
      },
      {
        id: 11,
        title: 'Amazon Web Services Dominates Cloud Market',
        subtitle: 'AWS maintains leadership position with 32% market share in cloud computing.',
        bullets: [
          'AWS revenue grows 17% to $25 billion in Q2',
          'AI and machine learning services drive adoption',
          'Enterprise migration to cloud accelerates'
        ],
        source: 'Bloomberg',
        date: new Date(Date.now() - 16200000).toISOString(),
        link: 'https://www.bloomberg.com/quote/AMZN:US',
        sentiment: 'bullish'
      },
      {
        id: 12,
        title: 'US Housing Market Shows Signs of Cooling',
        subtitle: 'Home sales decline as mortgage rates remain elevated above 7%.',
        bullets: [
          'Existing home sales down 2.5% month-over-month',
          'Median home price rises 4% year-over-year',
          'Inventory levels improving but still historically low'
        ],
        source: 'Reuters',
        date: new Date(Date.now() - 19800000).toISOString(),
        link: 'https://www.reuters.com/markets/us/',
        sentiment: 'neutral'
      },
    ],
    'en-GB': [
      {
        id: 13,
        title: 'Bank of England Considers August Rate Cut',
        subtitle: 'UK central bank signals potential easing as inflation approaches 2% target.',
        bullets: [
          'CPI inflation falls to 2.3% in latest reading',
          'Markets pricing 60% chance of August rate cut',
          'Sterling weakens against dollar and euro'
        ],
        source: 'BBC',
        date: new Date(Date.now() - 3000000).toISOString(),
        link: 'https://www.bbc.com/news/business',
        sentiment: 'neutral'
      },
      {
        id: 14,
        title: 'FTSE 100 Reaches New Record High',
        subtitle: 'UK\'s leading index surpasses 8,400 points amid global market rally.',
        bullets: [
          'Mining and energy stocks lead the advance',
          'Shell and BP contribute significantly to gains',
          'Export-focused companies benefit from weaker pound'
        ],
        source: 'BBC',
        date: new Date(Date.now() - 6600000).toISOString(),
        link: 'https://www.bbc.com/news/business/market-data',
        sentiment: 'bullish'
      },
      {
        id: 15,
        title: 'UK Retail Sales Surprise to the Upside',
        subtitle: 'Consumer spending shows resilience despite cost of living pressures.',
        bullets: [
          'Retail sales up 2.9% in May, beating expectations',
          'Online sales continue to grow at 5% annually',
          'Food retailers report strongest performance'
        ],
        source: 'Financial Times',
        date: new Date(Date.now() - 10200000).toISOString(),
        link: 'https://www.ft.com/uk-business-economy',
        sentiment: 'bullish'
      },
      {
        id: 16,
        title: 'AstraZeneca Secures Major Cancer Drug Approval',
        subtitle: 'Pharmaceutical giant receives FDA approval for new oncology treatment.',
        bullets: [
          'New drug targets specific form of lung cancer',
          'Expected to generate $2 billion in annual sales',
          'Stock rises 4% in London trading'
        ],
        source: 'Reuters',
        date: new Date(Date.now() - 13800000).toISOString(),
        link: 'https://www.reuters.com/business/healthcare-pharmaceuticals/',
        sentiment: 'bullish'
      },
      {
        id: 17,
        title: 'UK Property Market Stabilizes After Correction',
        subtitle: 'House prices show first monthly increase in six months.',
        bullets: [
          'Average house price rises 0.3% in June',
          'London market remains subdued with 0.5% decline',
          'First-time buyer activity increases'
        ],
        source: 'BBC',
        date: new Date(Date.now() - 17400000).toISOString(),
        link: 'https://www.bbc.com/news/business/economy',
        sentiment: 'neutral'
      },
      {
        id: 18,
        title: 'Barclays Reports Strong Trading Revenue',
        subtitle: 'Investment banking division outperforms expectations in volatile markets.',
        bullets: [
          'Trading revenue up 25% year-over-year',
          'Fixed income division leads the gains',
          'Bank announces £1 billion share buyback'
        ],
        source: 'Financial Times',
        date: new Date(Date.now() - 21000000).toISOString(),
        link: 'https://www.ft.com/companies/banks',
        sentiment: 'bullish'
      },
    ],
    hi: [
      {
        id: 19,
        title: 'सेंसेक्स ने बनाया नया रिकॉर्ड, 74,000 के पार',
        subtitle: 'विदेशी निवेशकों की जोरदार खरीदारी से भारतीय शेयर बाजार में तेजी जारी।',
        bullets: [
          'सेंसेक्स पहली बार 74,000 के ऊपर बंद',
          'निफ्टी 50 ने 22,500 का स्तर छुआ',
          'बैंकिंग और आईटी शेयरों में भारी तेजी'
        ],
        source: 'Moneycontrol Hindi',
        date: new Date(Date.now() - 1800000).toISOString(),
        link: 'https://www.moneycontrol.com/hindi/',
        sentiment: 'bullish'
      },
      {
        id: 20,
        title: 'आरबीआई ने ब्याज दर में कोई बदलाव नहीं किया',
        subtitle: 'रेपो रेट 6.5% पर स्थिर, मुद्रास्फीति पर नजर बनाए रखने का फैसला।',
        bullets: [
          'रेपो रेट लगातार आठवीं बार 6.5% पर स्थिर',
          'आर्थिक विकास दर का अनुमान 7.2% किया',
          'खुदरा मुद्रास्फीति 4.5% रहने का अनुमान'
        ],
        source: 'Moneycontrol Hindi',
        date: new Date(Date.now() - 4800000).toISOString(),
        link: 'https://www.moneycontrol.com/hindi/news/business/economy/',
        sentiment: 'neutral'
      },
      {
        id: 21,
        title: 'रिलायंस इंडस्ट्रीज का ग्रीन एनर्जी में बड़ा निवेश',
        subtitle: 'मुकेश अंबानी ने 75,000 करोड़ के निवेश की घोषणा की।',
        bullets: [
          'सोलर पैनल और हाइड्रोजन में बड़ा निवेश',
          '2035 तक नेट जीरो कार्बन का लक्ष्य',
          'शेयर में 3% की तेजी दर्ज'
        ],
        source: 'Moneycontrol Hindi',
        date: new Date(Date.now() - 8400000).toISOString(),
        link: 'https://www.moneycontrol.com/hindi/stocksmarketsindia/',
        sentiment: 'bullish'
      },
      {
        id: 22,
        title: 'टाटा मोटर्स की EV बिक्री में दोगुनी वृद्धि',
        subtitle: 'भारत में इलेक्ट्रिक वाहनों की मांग तेजी से बढ़ रही है।',
        bullets: [
          'तिमाही में 50,000 इलेक्ट्रिक गाड़ियां बिकीं',
          'नेक्सन EV बनी सबसे ज्यादा बिकने वाली EV',
          '2025 तक 5 नई EV लॉन्च करेगी कंपनी'
        ],
        source: 'Moneycontrol Hindi',
        date: new Date(Date.now() - 12000000).toISOString(),
        link: 'https://www.moneycontrol.com/hindi/news/business/stocks/',
        sentiment: 'bullish'
      },
      {
        id: 23,
        title: 'सोने की कीमतों में उछाल',
        subtitle: 'अंतरराष्ट्रीय बाजार में सोना 2,400 डॉलर के करीब पहुंचा।',
        bullets: [
          '24 कैरेट सोना 72,000 रुपये प्रति 10 ग्राम',
          'भू-राजनीतिक तनाव से सोने में तेजी',
          'शादी के सीजन में मांग बढ़ने की उम्मीद'
        ],
        source: 'Moneycontrol Hindi',
        date: new Date(Date.now() - 15600000).toISOString(),
        link: 'https://www.moneycontrol.com/hindi/commodity/',
        sentiment: 'bullish'
      },
      {
        id: 24,
        title: 'रुपया डॉलर के मुकाबले कमजोर',
        subtitle: 'विदेशी मुद्रा बाजार में रुपये पर दबाव जारी।',
        bullets: [
          'रुपया 83.50 के पार फिसला',
          'कच्चे तेल की ऊंची कीमतें कारण',
          'RBI के हस्तक्षेप से गिरावट पर रोक'
        ],
        source: 'Moneycontrol Hindi',
        date: new Date(Date.now() - 19200000).toISOString(),
        link: 'https://www.moneycontrol.com/hindi/currency/',
        sentiment: 'bearish'
      },
    ],
  };

  return newsData[language] || newsData.en;
};

export default getMockNews;
